module.exports = __webpack_public_path__ + "img/07.57a348d4.png";